@if (toasts().length > 0) {
  <div class="cads-global-toast-host" aria-label="Notifications">
    @for (toast of toasts(); track toast.id) {
      <cads-toast
        [config]="{
          message: toast.message,
          variant: toast.variant,
          exiting: toast.exiting,
        }"
      />
    }
  </div>
}
